import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, {} = user
  const [error, setError] = useState("");

  const fetchMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  };

  useEffect(() => {
    fetchMe();
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("lim_token", data.access_token);
      setUser({ id: data.id, email: data.email, name: data.name, role: data.role, title: data.title, team: data.team, avatar_url: data.avatar_url, is_super_admin: data.is_super_admin, is_admin: data.is_admin });
      return true;
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const updateUser = (patch) => setUser((u) => (u ? { ...u, ...patch } : u));

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("lim_token");
    // Kill any vault unlocks so re-logging in demands the password again.
    try {
      sessionStorage.removeItem("vault-unlock:finance");
      sessionStorage.removeItem("vault-unlock:hot_leads");
    } catch (_) { /* not available in some contexts */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error, refresh: fetchMe, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
